<template>
    <div class="card">
        <div class="card-header bg-info">
            <h3 class="my-0">Listado de unidades</h3>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col">
                    <button type="button" class="btn btn-custom btn-sm  mt-2 mr-2" @click.prevent="clickCreate()"><i class="fa fa-plus-circle"></i> Nuevo</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Código</th>
                        <th>Descripción</th>
                        <th>Mostrar en PDF</th>
                        <th>Símbolo</th>
                        <th class="text-center">Activo</th>
                        <th class="text-right">Acciones</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, index) in records" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ row.id }}</td>
                        <td>{{ row.description }}</td>
                        <td>
                            <el-switch
                                v-model="row.show_symbol"
                                active-text="Símbolo"
                                inactive-text="Código"
                                @change="changeShowSymbol(row)"
                            >
                            </el-switch>
                        </td>
                        <td>{{ row.symbol }}</td>
                        <td class="text-center">{{ row.active }}</td>
                        <td class="text-right">
                            <button type="button" class="btn waves-effect waves-light btn-xs btn-info" @click.prevent="clickCreate(row.id)">Editar</button>

                            <template v-if="typeUser === 'admin' && row.id !== 'ZZ'">
                                <button type="button" class="btn waves-effect waves-light btn-xs btn-danger"  @click.prevent="clickDelete(row.id)">Eliminar</button>
                            </template>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <!-- <div class="row">
                <div class="col">
                    <button type="button" class="btn btn-custom btn-sm  mt-2 mr-2" @click.prevent="clickCreate()"><i class="fa fa-plus-circle"></i> Nuevo</button>
                </div>
            </div> -->
        </div>
        <unit-types-form :showDialog.sync="showDialog"
                         :recordId="recordId"></unit-types-form>
    </div>
</template>

<script>

    import UnitTypesForm from './form.vue'
    import {deletable} from '../../../mixins/deletable'

    export default {
        mixins: [deletable],
        props: ['typeUser'],
        components: {UnitTypesForm},
        data() {
            return {
                showDialog: false,
                resource: 'unit_types',
                recordId: null,
                records: [],
            }
        },
        created() {
            this.$eventHub.$on('reloadData', () => {
                this.getData()
            })
            this.getData()
        },
        methods: {
            getData() {
                this.$http.get(`/${this.resource}/records`)
                    .then(response => {
                        this.records = response.data.data
                    })
            },
            clickCreate(recordId = null) {
                this.recordId = recordId
                this.showDialog = true
            },
            clickDelete(id) {
                this.destroy(`/${this.resource}/${id}`).then(() =>
                    this.$eventHub.$emit('reloadData')
                )
            },

            changeShowSymbol(row) {
                if (!row.symbol && row.show_symbol) {
                    this.$message.info('Ingresar un valor de símbolo para poder activar')
                    row.show_symbol = false
                    return
                } else {

                    this.$http.post(`/${this.resource}/change-show-symbol`, row)
                        .then(response => {
                            if (response.data.success) {
                                this.$message.success('Se guardaron los cambios correctamente.')
                                this.$eventHub.$emit('reloadData')
                            } else {
                                this.$message.error('No se guardaron los cambios')
                            }
                        })
                        .catch(error => {
                            console.log(error)
                    })

                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/views/tenant/unit_types/index.vue